import {createContext, Dispatch, SetStateAction, useContext} from "react";
import {
  FileFragmentFragment,
  ZyusetuFieldValueAnalyzedPayloadFragmentFragment,
} from "@/graphql/graphql";

export interface HighlightFieldIFace {
  field?: ZyusetuFieldValueAnalyzedPayloadFragmentFragment | null;
  file?: FileFragmentFragment | null;
}

export const HighlightedField = createContext<HighlightFieldIFace>({});

export const SetHighlightedField = createContext<
  Dispatch<SetStateAction<HighlightFieldIFace>>
>(() => undefined);

export const useSetHighlightedField = () => useContext(SetHighlightedField);

export const useHighlightedField = () => useContext(HighlightedField);
